import React from 'react';
import Marquee from 'react-fast-marquee';
import CL1 from "../Assets/cl1.png";
import CL2 from "../Assets/cl2.jpg";
import CL3 from "../Assets/cl3.png";
import CL4 from "../Assets/cl4.png";
import CL5 from "../Assets/cl5.1";
import CL6 from "../Assets/cl6.png";
import CL7 from "../Assets/cl7.png";
import CL8 from "../Assets/cl8.png";
import CL9 from "../Assets/cl9.jpg";
import CL10 from "../Assets/cl10.png";


const Clients = () => {
  return (
    <div className="w-full flex flex-col justify-center items-center py-28 px-4  bg-gradient-to-r from-gray-50 to-gray-100">
      {/* Header Section */}
      <div className="w-full text-center mb-12">
      <h2 className="text-3xl sm:text-5xl font-semibold text-gray-800">Our Clients</h2>
        <p className="text-gray-600 mt-2 text-lg sm:text-xl">
          We are proud to collaborate with these amazing companies.
        </p>
      </div>

      {/* Marquee Section */}
      <Marquee gradient={true} gradientWidth={100} gradientColor={[245, 245, 245]} speed={50} direction="right" pauseOnHover>
        {[CL1, CL2, CL3, CL4, CL5, CL6, CL7, CL8, CL9, CL10,].map((client, index) => (
          <div key={index} className="flex justify-center items-center mx-8">
            <img
              className="h-16 sm:h-24 w-auto transition-transform duration-300 transform hover:scale-110 drop-shadow-md"
              src={client}
              alt={`Client ${index + 1}`}
            />
          </div>
        ))}
      </Marquee>
    </div>
  );
};

export default Clients;
